/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Estimate_From_RaceInputs */

const en_ui_thresholds_estimate_from_race = /** @type {(inputs: Ui_Thresholds_Estimate_From_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate from a race time`)
};

const de_ui_thresholds_estimate_from_race = /** @type {(inputs: Ui_Thresholds_Estimate_From_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus einer Wettkampfzeit schätzen`)
};

/**
* | output |
* | --- |
* | "Estimate from a race time" |
*
* @param {Ui_Thresholds_Estimate_From_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_estimate_from_race = /** @type {((inputs?: Ui_Thresholds_Estimate_From_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Estimate_From_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_estimate_from_race(inputs)
	return de_ui_thresholds_estimate_from_race(inputs)
});